var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "container", staticClass: "popover-container" },
    [
      _vm._t("default", function () {
        return [
          _c("i", {
            staticClass: "fa fa-question-circle",
            attrs: { "aria-hidden": "true" },
          }),
        ]
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "selectable",
          class: [
            "vtooltip",
            _vm.always ? "vtooltip-always" : "",
            "vtooltip-" + _vm.positionComputed,
          ],
          style: {
            color: _vm.color,
            backgroundColor: _vm.bgcolor,
            fontSize: _vm.textsize + "px",
            width: _vm.width + "px",
            textAlign: _vm.textAlign,
          },
          on: {
            click: function ($event) {
              $event.stopPropagation()
              $event.preventDefault()
            },
            blur: function ($event) {
              return _vm.hideHint()
            },
          },
        },
        [_vm._v("\n    " + _vm._s(_vm.text.trim()) + "\n  ")]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }